<template>
  <div>
    <div class="title">{{ title }}</div>
    <div class="button-container">
      <div class="header-back" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
      <selectViewRangeDialog
        ref="viewRange"
        dialog-title="添加人员/部门"
        @submitRange="addEntities"
      ></selectViewRangeDialog>
      <el-button type="primary" @click="openDialog">添加人员/部门</el-button>
      <el-button @click="removeEntities">移除</el-button>
    </div>
    <el-table :data="tableData" v-loading="tableLoading" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="user_name" label="人员/部门名称" width="180"></el-table-column>
      <el-table-column prop="department_name" label="所属部门"></el-table-column>
    </el-table>
    <el-dialog :visible.sync="dialogInvalid" title="添加错误">
      <div>以下人员/部门在导入企业微信时发生错误</div>
      <el-table :data="invalidUsers">
        <el-table-column prop="user_type" label="类型">
          <template slot-scope="scope">
            {{ scope.row.user_type === 1 ? '人员' : '部门' }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="人员/部门名称"></el-table-column>
      </el-table>
    </el-dialog>
    <div style="text-align: right">
      <el-pagination
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next"
        :page-sizes="g_pageSizesConfig"
        :total="pageTotal"
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="changePageIndex"
        @size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import { query } from '@/libs/utils/util';
import selectViewRangeDialog from '@/components/selectViewRangeDialog';
import {
  GetContactTagUserList,
  AddContactTagUsers,
  DelContactTagUsers,
  GetWeComDetailNameById,
} from '@/api/addressList';

export default {
  components: { selectViewRangeDialog },
  data() {
    return {
      title: '',
      tag_id: 0,
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 1,
      tableLoading: false,
      selection: [], // 选择的实体（人/部门）

      invalidUsers: [],
      dialogInvalid: false,
    };
  },
  created() {
    this.title = query('title');
    this.tag_id = Number.parseInt(query('id'), 10);
    this.getList();

    // 面包屑设置
    const breadcrumb = [
      { menu_name: '企业微信管理', menu_path: '' },
      { menu_name: '通讯录管理', menu_path: 'addressList', menu_params: { tabName: '2' } },
      { menu_name: '标签编辑' },
    ];
    this.$store.commit('user/setBreadcrumb', breadcrumb);
  },
  methods: {
    getList() {
      this.tableLoading = true;
      GetContactTagUserList({
        agent_id: -1,
        tag_id: this.tag_id,
        page_size: this.pageSize,
        page_index: this.pageIndex,
      })
        .then((res) => {
          this.tableData = res.users;
          this.pageTotal = res.total;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    changePageIndex(val) {
      this.pageIndex = val;
      this.selection.splice(0, this.selection.length);
      this.getList();
    },
    changePageSize(val) {
      this.pageSize = val;
      this.selection.splice(0, this.selection.length);
      this.getList();
    },
    openDialog() {
      this.$refs.viewRange.openDialog();
    },
    addEntities(confirm) {
      if (confirm) {
        const { departIds, userIds } = this.$refs.viewRange.submitForm();
        // eslint-disable-next-line camelcase
        const tag_users = [
          ...userIds.map((userId) => {
            return {
              user_type: 1, // 用户标签类型，1-人员；2-部门
              user_id: userId, // user_type=1,此字段为通讯录userid
            };
          }),
          ...departIds.map((departId) => {
            return {
              user_type: 2, // 用户标签类型，1-人员；2-部门
              user_id: departId, // user_type=2,此字段为department_id
            };
          }),
        ];
        AddContactTagUsers({
          tag_id: this.tag_id,
          tag_users,
        })
          .then((res) => {
            if (res.invalid_users.length) {
              this.handleInvalidUsers(res.invalid_users);
            } else {
              this.$message.success('添加成功！');
              this.changePageIndex(1);
            }
            this.$refs.viewRange.clearSelection();
          })
          .catch((e) => {
            this.$message.error(e);
          });
        console.log(departIds);
        console.log(userIds);
      }
      this.$refs.viewRange.closeDialog();
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    removeEntities() {
      console.log(this.selection);
      if (this.selection.length === 0) {
        this.$message.warning('请选择要移除的人员/部门');
        return;
      }
      this.$confirm('确定移除选中的人员/部门吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // const tag_users = ;
        DelContactTagUsers({
          tag_id: this.tag_id,
          tag_users: this.selection.map(({ user_type, user_id }) => {
            return { user_type, user_id };
          }),
        })
          .then((res) => {
            if (res.invalid_users.length) {
              this.handleInvalidUsers(res.invalid_users);
            } else {
              this.$message.success('移除成功！');
              this.changePageIndex(1);
            }
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
    handleInvalidUsers(invalidUsers) {
      const userIdList = [];
      const departmentIdList = [];

      for (const item of invalidUsers) {
        if (item.user_type === 1 && item.user_id) {
          userIdList.push(item.user_id);
        } else if (item.user_type === 2) {
          departmentIdList.push(item.user_id);
        }
      }
      GetWeComDetailNameById({
        user_id_list: userIdList,
        department_id_list: departmentIdList,
      })
        .then(({ user_detail_list, department_detail_list }) => {
          for (const item of invalidUsers) {
            if (item.user_type === 1) {
              item.name = user_detail_list.filter((user) => {
                return user.userid === item.user_id;
              })[0].name;
            } else if (item.user_type === 2) {
              item.name = department_detail_list.filter((depart) => {
                return depart.id === item.user_id;
              })[0].name;
            }
          }
          this.invalidUsers = invalidUsers;
          this.dialogInvalid = true;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    goBack() {
      this.g_tourl('/saas/addressList.html?tabName=2');
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #edeff2;
}
.button-container {
  position: relative;
  padding: 10px 0;
  text-align: right;
  .header-back {
    position: absolute;
    left: 0;
    top: 15px;
    cursor: pointer;
  }
}
</style>
